import { render, staticRenderFns } from "./PurchaseDetail.vue?vue&type=template&id=382f1b5d&"
import script from "./PurchaseDetail.vue?vue&type=script&lang=js&"
export * from "./PurchaseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('382f1b5d')) {
      api.createRecord('382f1b5d', component.options)
    } else {
      api.reload('382f1b5d', component.options)
    }
    module.hot.accept("./PurchaseDetail.vue?vue&type=template&id=382f1b5d&", function () {
      api.rerender('382f1b5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/PurchaseDetail.vue"
export default component.exports